import * as React from "react";
// import { Link } from 'gatsby';
import * as s from "@gromia/components/theme/t.module.css";
import { MarketingItem } from "@gromia/components/ui/MarketingItem";
import { Text } from "@gromia/components/ui/Text";
import strings from "@gromia/strings/landingSell";
import { useString } from "@gromia/utils/useString";
import cx from "classnames";

export function Professionals(props: { className: string }) {
  const { tx } = useString("landingSell", strings);
  return (
    <section className={cx(props.className, s.space2, s.positionRelative)}>
      <div className={cx(s.container)}>
        <div className={cx(s.row)}>
          <div
            className={cx(
              s.colLg5,
              s.prLg5,
              s.ptLg5,
              s.textAlignCenter,
              s.textAlignLgLeft,
            )}
          >
            <Text tag="p" s="pill">
              {tx("prosPill")}
            </Text>
            <Text tag="h2" s="title">
              {tx("prosTitle")}
            </Text>
            <Text tag="p" s="p">
              {tx("prosText1")}
            </Text>
            <Text tag="p" s="p">
              {tx("prosText2")}
            </Text>
          </div>
          <div className={cx(s.colLg7, s.mt5, s.mtLg0)}>
            <div className={cx(s.row)}>
              <div className={cx(s.colSm6, s.mb4)}>
                <MarketingItem
                  src={require("@gromia/components/images/icon-agents.svg")
                    .default}
                  title={tx("pros1Title")}
                >
                  {tx("pros1Text")}
                </MarketingItem>
              </div>
              <div className={cx(s.colSm6, s.mb4)}>
                <MarketingItem
                  src={require("@gromia/components/images/icon-marketing.svg")
                    .default}
                  title={tx("pros2Title")}
                >
                  {tx("pros2Text")}
                </MarketingItem>
              </div>
              <div className={cx(s.colSm6, s.mb4)}>
                <MarketingItem
                  src={require(
                    "@gromia/components/images/icon-customer-care.svg",
                  )
                    .default}
                  title={tx("pros3Title")}
                >
                  {tx("pros3Text")}
                </MarketingItem>
              </div>
              <div className={cx(s.colSm6, s.mb4)}>
                <MarketingItem
                  src={require("@gromia/components/images/icon-camera.svg")
                    .default}
                  title={tx("pros4Title")}
                >
                  {tx("pros4Text")}
                </MarketingItem>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
